module.exports = __webpack_public_path__ + "static/media/transunion-cibil-logo.253faca1.png";